import React, { Component } from 'react';
//STYLE
import { Container } from 'reactstrap';
//COMPONENTS
import Header from '../staticComponents/header'
import Footer from '../staticComponents/footer'
import VehiclePresentation from '../modules/vehiclePresentation'

class Vehicles extends Component {
  render() {
    return (
      <div>
        <Header path={this.props.match} />
        <Container id="allVehicles" className="edit_pd">
          <VehiclePresentation
            type = {this.props.match.params.type}
           />
        </Container>
        <Footer />
      </div>
    );
  }
}

export default Vehicles;
